import UtilityServiceOrganizationPictures from "../API/common/UtilityServiceOrganizationPictures";
import CustomerPicturesService from "../API/customer/CustomerPicturesService";
import {
    getCachedTexturePictures,
    putCachedTexturePictures,
} from "./compositionTexturePictureCache";
import {
    getMockTexturesByIds,
    isMockTextureId,
} from "./mockCompositionTextureCatalog";

const normalizePictureList = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (payload != null && typeof payload === "object") {
        return Object.values(payload);
    }
    return [];
};

const fetchByIdsApi = (scope, missingIds) => (
    scope === "customer"
        ? CustomerPicturesService.getTexturedByIds(missingIds)
        : UtilityServiceOrganizationPictures.getTexturedByIds(missingIds)
);

/**
 * PictureDto[] по id с in-memory кешем (organization | customer).
 * Mock-id из фронтового пула не ходят на API.
 * @param {'organization'|'customer'} scope
 * @param {number[]} ids
 */
export const fetchCompositionTexturePicturesByIds = async (scope, ids) => {
    const unique = [...new Set(
        (Array.isArray(ids) ? ids : [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id) && id !== 0),
    )];
    if (unique.length === 0) {
        return [];
    }

    const mockIds = unique.filter((id) => isMockTextureId(id));
    const mockPictures = getMockTexturesByIds(mockIds);
    const remoteIds = unique.filter((id) => !isMockTextureId(id));

    if (remoteIds.length === 0) {
        return mockPictures;
    }

    const {pictures: cached, missing} = getCachedTexturePictures(scope, remoteIds);
    let fetched = [];
    if (missing.length > 0) {
        const response = await fetchByIdsApi(scope, missing);
        fetched = normalizePictureList(response?.data);
        putCachedTexturePictures(scope, fetched);
    }

    const {pictures: mergedRemote} = getCachedTexturePictures(scope, remoteIds);
    const remoteList = mergedRemote.length > 0 ? mergedRemote : [...cached, ...fetched];

    const byId = new Map();
    for (const row of [...remoteList, ...mockPictures]) {
        if (row?.id != null) {
            byId.set(Number(row.id), row);
        }
    }
    return unique.map((id) => byId.get(id)).filter(Boolean);
};
